import React, { useState, useEffect } from 'react';
import './ModelSelector.css';

const API_URL = 'https://cv.ainnect.me';

const ModelSelector = ({ selectedModel, onModelSelect }) => {
  const [models, setModels] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const response = await fetch(`${API_URL}/models`);
        if (!response.ok) {
          throw new Error('Failed to fetch models');
        }
        const data = await response.json();
        setModels(data.models);
        
        // If no model is selected yet, select the first one or 'best_v8s' if available
        if (!selectedModel) {
          const modelKeys = Object.keys(data.models);
          if (modelKeys.length > 0) {
            const defaultModel = modelKeys.includes('best_v8s') ? 'best_v8s' : modelKeys[0];
            onModelSelect(defaultModel);
          }
        }
      } catch (err) {
        console.error('Error fetching models:', err);
        setError('Could not load models');
        // Fallback to hardcoded list if API fails
        const fallbackModels = {
            "best_v8n": { "path": "best_v8n.pt", "exists": true },
            "best_v8s": { "path": "best_v8s.pt", "exists": true },
            "best_v8l": { "path": "best_v8l.pt", "exists": true },
            "best_rt_detect": { "path": "best_rt_detr_l.pt", "exists": true }
        };
        setModels(fallbackModels);
        if (!selectedModel) onModelSelect('best_v8s');
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, [selectedModel, onModelSelect]);

  return (
    <div className="model-selector">
      <label htmlFor="model-select" className="model-label">Chọn Model:</label>
      <select
        id="model-select"
        value={selectedModel || ''}
        onChange={(e) => onModelSelect(e.target.value)}
        className="model-dropdown"
        disabled={loading}
      >
        {loading ? (
          <option>Đang tải...</option>
        ) : (
          Object.keys(models).map((modelName) => (
            <option key={modelName} value={modelName}>
              {modelName}
            </option>
          ))
        )}
      </select>
      {error && <span className="model-error" title={error}>⚠️</span>}
    </div>
  );
};

export default ModelSelector;
